import { AbstractControl, ValidatorFn } from '@angular/forms';

export const cnpjValidator: ValidatorFn = (
  control: AbstractControl,
): { [key: string]: boolean } | null => {
  if (control.value === '' || control.value === null) return null;

  const cnpj = control.value.toString().toUpperCase();

  if (/^\d{14}$/.test(cnpj)) {
    if ([...Array(10).keys()].some(n => cnpj === String(n).repeat(14)))
      return { CNPJinvalid: true };
  }

  const charParaValor = (c: string): number =>
    c >= '0' && c <= '9'
      ? parseInt(c)
      : c.charCodeAt(0) - 'A'.charCodeAt(0) + 17;

  const calcularDV = (trecho: string): number => {
    const tamanho = trecho.length;
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += charParaValor(trecho.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    return soma % 11 < 2 ? 0 : 11 - (soma % 11);
  };

  const tamanho = cnpj.length - 2;
  const digitos = cnpj.substring(tamanho);

  if (calcularDV(cnpj.substring(0, tamanho)) !== parseInt(digitos.charAt(0)))
    return { CNPJinvalid: true };

  if (calcularDV(cnpj.substring(0, tamanho + 1)) !== parseInt(digitos.charAt(1)))
    return { CNPJinvalid: true };

  return null;
};
